import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "body-child" }
const _hoisted_2 = { class: "content main" }
const _hoisted_3 = { class: "text" }
const _hoisted_4 = { class: "content block" }
const _hoisted_5 = { class: "text" }
const _hoisted_6 = { style: {"text-align":"left"} }
const _hoisted_7 = { class: "content" }
const _hoisted_8 = { class: "text" }
const _hoisted_9 = { style: {"text-align":"left"} }
const _hoisted_10 = { class: "content block" }
const _hoisted_11 = { class: "text" }
const _hoisted_12 = { style: {"text-align":"left"} }
const _hoisted_13 = { class: "timeline" }
const _hoisted_14 = { class: "timeline-content" }
const _hoisted_15 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Accent = _resolveComponent("Accent")!
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[39] || (_cache[39] = _createElementVNode("div", { class: "about-background" }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _cache[37] || (_cache[37] = _createElementVNode("picture", { class: "profile-picture" }, [
        _createElementVNode("source", {
          srcset: "/src/img/me.webp",
          type: "image/webp"
        }),
        _createElementVNode("source", {
          srcset: "/src/img/me.jpg",
          type: "image/jpg"
        }),
        _createElementVNode("img", {
          src: "/src/img/me.jpg",
          alt: ""
        })
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _cache[33] || (_cache[33] = _createElementVNode("h1", { style: {"margin-top":"0"} }, "Who am I?", -1)),
        _createElementVNode("p", null, [
          _cache[2] || (_cache[2] = _createTextVNode(" Hi! I’m ")),
          _createVNode(_component_Accent, null, {
            default: _withCtx(() => _cache[0] || (_cache[0] = [
              _createTextVNode("Kylian Dekker")
            ])),
            _: 1
          }),
          _createTextVNode(", a " + _toDisplayString(_ctx.AGE()) + "-year old gameplay programmer from the Netherlands with ", 1),
          _createVNode(_component_Accent, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.PROGRAMMING_EXPERIENCE_AAA()), 1)
            ]),
            _: 1
          }),
          _cache[3] || (_cache[3] = _createTextVNode(" years of professional experience in the AAA industry and ")),
          _createVNode(_component_Accent, null, {
            default: _withCtx(() => _cache[1] || (_cache[1] = [
              _createTextVNode("2")
            ])),
            _: 1
          }),
          _cache[4] || (_cache[4] = _createTextVNode(" years in Indie Games. "))
        ]),
        _createElementVNode("p", null, [
          _createTextVNode(" I started programming in " + _toDisplayString(_ctx.PROGRAMMING_YEAR()) + " and I studied indie game programming at ", 1),
          _createVNode(_component_Accent, null, {
            default: _withCtx(() => _cache[5] || (_cache[5] = [
              _createTextVNode("SintLucas Eindhoven")
            ])),
            _: 1
          }),
          _cache[9] || (_cache[9] = _createTextVNode(" and later specialized in AAA development at ")),
          _createVNode(_component_Accent, null, {
            default: _withCtx(() => _cache[6] || (_cache[6] = [
              _createTextVNode("Breda University of Applied Sciences")
            ])),
            _: 1
          }),
          _cache[10] || (_cache[10] = _createTextVNode(" (formerly ")),
          _createVNode(_component_Accent, null, {
            default: _withCtx(() => _cache[7] || (_cache[7] = [
              _createTextVNode("NHTV")
            ])),
            _: 1
          }),
          _cache[11] || (_cache[11] = _createTextVNode("), graduating with a ")),
          _createVNode(_component_Accent, null, {
            default: _withCtx(() => _cache[8] || (_cache[8] = [
              _createTextVNode("Cum Laude/First Class Bachelor of Science (Hons)")
            ])),
            _: 1
          }),
          _cache[12] || (_cache[12] = _createTextVNode(". "))
        ]),
        _createElementVNode("p", null, [
          _cache[15] || (_cache[15] = _createTextVNode(" In 2018, I won the ")),
          _createVNode(_component_Accent, null, {
            default: _withCtx(() => _cache[13] || (_cache[13] = [
              _createTextVNode("INDIGO Award for Best Indie Game")
            ])),
            _: 1
          }),
          _cache[16] || (_cache[16] = _createTextVNode(" for my game named ")),
          _createVNode(_component_Accent, null, {
            default: _withCtx(() => _cache[14] || (_cache[14] = [
              _createTextVNode("CoopScoop")
            ])),
            _: 1
          }),
          _cache[17] || (_cache[17] = _createTextVNode(". "))
        ]),
        _cache[34] || (_cache[34] = _createElementVNode("p", null, "Some of the most important titles I have worked on thus far are:", -1)),
        _cache[35] || (_cache[35] = _createElementVNode("ul", null, [
          _createElementVNode("li", null, "Microsoft Flight Simulator 2024"),
          _createElementVNode("li", null, "Arma 4"),
          _createElementVNode("li", null, "Unannounced Title in DayZ Series")
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[21] || (_cache[21] = _createElementVNode("h3", null, "Programming Languages", -1)),
            _createElementVNode("ul", _hoisted_6, [
              _createElementVNode("li", null, [
                _createVNode(_component_Icon, { icon: 'cpp' }),
                _cache[18] || (_cache[18] = _createTextVNode(" C++"))
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_Icon, { icon: 'csharp' }),
                _cache[19] || (_cache[19] = _createTextVNode(" C#"))
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_Icon, { icon: 'js' }),
                _cache[20] || (_cache[20] = _createTextVNode(" Javascript/Typescript/Vue.js"))
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _cache[27] || (_cache[27] = _createElementVNode("h3", null, "Programming Software", -1)),
            _createElementVNode("ul", _hoisted_9, [
              _createElementVNode("li", null, [
                _createVNode(_component_Icon, { icon: 'git' }),
                _cache[22] || (_cache[22] = _createTextVNode(" Git"))
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_Icon, { icon: 'perforce' }),
                _cache[23] || (_cache[23] = _createTextVNode(" Perforce"))
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_Icon, { icon: 'unity' }),
                _cache[24] || (_cache[24] = _createTextVNode(" Unity Engine"))
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_Icon, { icon: 'visual-studio' }),
                _cache[25] || (_cache[25] = _createTextVNode(" Microsoft Visual Studio"))
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_Icon, { icon: 'visual-studio-code' }),
                _cache[26] || (_cache[26] = _createTextVNode(" Microsoft Visual Studio Code"))
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _cache[32] || (_cache[32] = _createElementVNode("h3", null, "Platforms", -1)),
            _createElementVNode("ul", _hoisted_12, [
              _createElementVNode("li", null, [
                _createVNode(_component_Icon, { icon: 'windows' }),
                _cache[28] || (_cache[28] = _createTextVNode(" Windows"))
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_Icon, { icon: 'playstation' }),
                _cache[29] || (_cache[29] = _createTextVNode(" Playstation 4"))
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_Icon, { icon: 'playstation' }),
                _cache[30] || (_cache[30] = _createTextVNode(" Playstation 5"))
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_Icon, { icon: 'vr' }),
                _cache[31] || (_cache[31] = _createTextVNode(" Oculus and SteamVR"))
              ])
            ])
          ])
        ]),
        _cache[36] || (_cache[36] = _createElementVNode("div", { class: "content" }, [
          _createElementVNode("div", { class: "text" }, [
            _createElementVNode("h3", null, "Languages"),
            _createElementVNode("ul", { style: {"text-align":"left"} }, [
              _createElementVNode("li", null, "Dutch"),
              _createElementVNode("li", null, "English")
            ])
          ])
        ], -1))
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.events, (event) => {
        return (_openBlock(), _createElementBlock("div", {
          key: event.name,
          class: "timeline-item"
        }, [
          _cache[38] || (_cache[38] = _createElementVNode("div", { class: "timeline-dot" }, null, -1)),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("img", {
              class: "timeline-image",
              src: event.logo,
              alt: "Image did not load. ;/"
            }, null, 8, _hoisted_15),
            _createElementVNode("h3", null, _toDisplayString(event.getDateFormatted()) + " " + _toDisplayString(event.getTimeSince()), 1),
            _createElementVNode("h2", null, _toDisplayString(event.name), 1),
            (_openBlock(), _createBlock(_resolveDynamicComponent(event.description)))
          ])
        ]))
      }), 128))
    ])
  ]))
}